// extracted by mini-css-extract-plugin
export default {"tabsContainer":"Previews_tabsContainer__5e8sN","link":"Previews_link__MZYwU"};